(function ($) {
    'use strict';

    var cookieManager = {
        getItem: function (sKey) {
            if (!sKey) {
                return null;
            }
            return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
        },
        setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
            if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
                return false;
            }
            var sExpires = "";
            if (vEnd) {
                switch (vEnd.constructor) {
                    case Number:
                        sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                        break;
                    case String:
                        sExpires = "; expires=" + vEnd;
                        break;
                    case Date:
                        sExpires = "; expires=" + vEnd.toUTCString();
                        break;
                }
            }
            document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
            return true;
        },
        removeItem: function (sKey, sPath, sDomain) {
            if (!this.hasItem(sKey)) {
                return false;
            }
            document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
            return true;
        },
        hasItem: function (sKey) {
            if (!sKey) {
                return false;
            }
            return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
        },
        keys: function () {
            var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
            for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
                aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
            }
            return aKeys;
        }
    };


    $('.popup_open_track').click(function () {
        var label = jQuery(this).data('id');
        var ck = jQuery(this).data('ck');
        if (cookieManager.hasItem(ck)) {
            var ock = parseInt(cookieManager.getItem(ck)) + parseInt(1)
            cookieManager.setItem(ck, ock, false, '/');
        } else {
            cookieManager.setItem(ck, 1, false, '/');
        }
        var ckv = cookieManager.getItem(ck);

        // Safe gtag tracking with error handling
        try {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'Open popup', {
                    'event_category': 'Popup',
                    'event_label': label,
                    'event_value': ckv
                });
            }
        } catch (e) {
            console.log('gtag tracking failed:', e);
        }

        // Safe mixpanel tracking with error handling
        try {
            if (typeof mixpanel !== 'undefined') {
                mixpanel.track("Popup", {
                    "Action": "Open Popup",
                    "Type": "Popup",
                    "Label": label
                });
            }
        } catch (e) {
            console.log('Mixpanel tracking failed:', e);
        }

        console.log("Popup Opened " + ckv + " times");
    })

    $('#newsletter_section #contact_form').submit(function () {
        // Safe gtag tracking with error handling
        try {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'Submitted', {
                    'event_category': 'Subscribe',
                    'event_label': 'subscription'
                });
            }
        } catch (e) {
            console.log('gtag tracking failed:', e);
        }

        // Safe mixpanel tracking with error handling
        try {
            if (typeof mixpanel !== 'undefined') {
                mixpanel.track("Subscribe", {
                    "Action": "Submitted",
                    "Type": "Subscribe",
                    "Label": "subscription"
                });
            }
        } catch (e) {
            console.log('Mixpanel tracking failed:', e);
        }

        console.log("Subscription Submitted");
    })

    $('#exit-pop #contact_form').submit(function () {
        // Safe gtag tracking with error handling
        try {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'Submitted', {
                    'event_category': 'Subscribe',
                    'event_label': 'exit popup subscription'
                });
            }
        } catch (e) {
            console.log('gtag tracking failed:', e);
        }

        // Safe mixpanel tracking with error handling
        try {
            if (typeof mixpanel !== 'undefined') {
                mixpanel.track("Subscribe", {
                    "Action": "Submitted",
                    "Type": "Subscribe",
                    "Label": "exit popup subscription"
                });
            }
        } catch (e) {
            console.log('Mixpanel tracking failed:', e);
        }
        console.log("Subscription Submitted");
    })


    var Timer = (function () {
        var timer = null;

        return {
            start: function () {
                timer = (new Date).getTime();
                return null;
            },
            stop: function () {
                var now = (new Date).getTime();
                now = (now - timer) / 1000;
                timer = 0;

                return now;
            },
            restart: function () {
                var diff = Timer.stop();
                Timer.start();

                return diff;
            }
        };
    }());


    $('.accordin_title,.faq-a').click(function (ev) {
        ev.preventDefault();
        var selector = $(this);
        var item_parent = selector.parents('.faq-item');
        var content = item_parent.find('.faq-a');
        var clabel = selector.closest('.accordin_title').attr('id');


        item_parent.toggleClass('active');
        var content_height = content.css('height');
        content.css('height', 'auto');
        var content_a_height = content.css('height');
        content.css('height', content_height);

        if (item_parent.hasClass('active')) {
            $(content).animate({
                height: content_a_height
            }, 300, function () {
                $(this).addClass('preview-active');
            });

            gtag('event', 'Open Question', {
                'event_category': 'FAQ',
                'event_label': clabel
            });

            mixpanel.track("FAQ", {
                "Action": "Open Question",
                "Type": "FAQ",
                "Label": clabel
            });



            Timer.start();
            console.log("FAQ Question Opened " + clabel);

        } else {
            $(content).animate({
                height: 24
            }, 300, function () {
                $(this).removeClass('preview-active');
            });
            var ctime = Timer.stop();
            gtag('event', 'Closed Question', {
                'event_category': 'FAQ',
                'event_label': clabel,
                'event_value': ctime
            });
            mixpanel.track("FAQ", {
                "Action": "Closed Question",
                "Type": "FAQ",
                "Label": clabel
            });


            console.log("FAQ Question Closed After " + ctime + " Seconds");
        }
        return false;
    });




    $(document).on("click", "#faq-toggle-btn", function () {
        var $this = $(this);

        if ($this.is(".t-active")) {
            gtag('event', 'Open Section', {
                'event_category': 'FAQ',
                'event_label': 'FAQ section'
            });
            mixpanel.track("FAQ", {
                "Action": "Open Section",
                "Type": "FAQ",
                "Label": "FAQ section"
            });
            Timer.start();
            console.log("FAQ Section Opened");
        } else {
            var ctime = Timer.stop();
            gtag('event', 'Closed Section', {
                'event_category': 'FAQ',
                'event_label': 'FAQ section',
                'event_value': ctime
            });
            mixpanel.track("FAQ", {
                "Action": "Closed Section",
                "Type": "FAQ",
                "Label": "FAQ section"
            });
            console.log("FAQ Section Closed After " + ctime + " Seconds");
        }
    });




    $(document).on("click", ".open-size-chart", function () {



        gtag('event', 'Open Size Chart', {
            'event_category': 'Open Size Chart',
            'event_label': 'Open Size Chart',
            'event_value': 'Open Size Chart'
        });
        mixpanel.track("Open Size Chart", {
            "Action": "Open Size Chart",
            "Type": "Open Size Chart",
            "Label": "Open Size Chart"
        });

        console.log("Open Size Chart");


    });




    $("#cartQty").on("click", function () {

        // Safe gtag tracking with error handling
        try {
            if (typeof gtag !== 'undefined') {
                gtag('event', 'View Cart', {
                    'event_category': 'View Cart',
                    'event_label': 'View Cart',
                    'event_value': 'View Cart'
                });
            }
        } catch (e) {
            console.log('gtag tracking failed:', e);
        }

        // Safe mixpanel tracking with error handling
        try {
            if (typeof mixpanel !== 'undefined') {
                mixpanel.track("View Cart", {
                    "Action": "View Cart",
                    "Type": "View Cart",
                    "Label": "View Cart"
                });
            }
        } catch (e) {
            console.log('Mixpanel tracking failed:', e);
        }

        console.log("View Cart");


    });




    document.addEventListener("mouseleave", function (e) {
        if (e.clientY < 0) {
            if (cookieManager.hasItem('exit-pop')) {
                console.log("Already closed once");
            } else {

                $.magnificPopup.open({
                    items: {
                        src: '#exit-pop'
                    },
                    type: 'inline',
                    callbacks: {
                        open: function () {
                            cookieManager.setItem('exit-pop', '1', false, '/');
                            // Safe gtag tracking with error handling
                            try {
                                if (typeof gtag !== 'undefined') {
                                    gtag('event', 'Open popup', { 'event_category': 'Popup', 'event_label': 'exit popup opened' });
                                }
                            } catch (e) {
                                console.log('gtag tracking failed:', e);
                            }
                            console.log("Popup Opened");
                            // Safe mixpanel tracking with error handling
                            try {
                                if (typeof mixpanel !== 'undefined') {
                                    mixpanel.track("Popup", {
                                        "Action": "Open Popup",
                                        "Type": "Popup",
                                        "Label": "Exit popup Opened"
                                    });
                                }
                            } catch (e) {
                                console.log('Mixpanel tracking failed:', e);
                            }
                            $('#exit-pop .close-popup').on('click', function (event) {
                                event.preventDefault();
                                $.magnificPopup.close();
                            });
                        },
                        close: function () {
                            cookieManager.setItem('exit-pop', '1', false, '/');
                            // Safe gtag tracking with error handling
                            try {
                                if (typeof gtag !== 'undefined') {
                                    gtag('event', 'Close popup', { 'event_category': 'Popup', 'event_label': 'exit popup closed' });
                                }
                            } catch (e) {
                                console.log('gtag tracking failed:', e);
                            }
                            console.log("Popup Closed");
                            // Safe mixpanel tracking with error handling
                            try {
                                if (typeof mixpanel !== 'undefined') {
                                    mixpanel.track("Popup", {
                                        "Action": "Close Popup",
                                        "Type": "Popup",
                                        "Label": "Exit popup Closed"
                                    });
                                }
                            } catch (e) {
                                console.log('Mixpanel tracking failed:', e);
                            }
                        }
                    }
                });

            }
        }
    }, false);



    var GoogleAnalytics = (function () {
        function isGALoaded() {
            if (typeof ga !== 'function') {
                window.console.log('Google Analytics not Present');
                return false;
            }

            if (window.gaplugins === undefined || window.gaplugins.EC === undefined) {
                ga('require', 'ec');
            }

            return true;
        }

        function trackEvent(code, status, balance) {
            var data = {
                eventCategory: 'Code Check',
                eventAction: status,
                eventLabel: balance,
                eventValue: code
            };
            ga('send', 'event', data);
        }

        function trackECommerce(code, balance) {
            if (isNaN(balance)) {
                return null;
            }

            ga('ec:addPromo', {
                id: 'codecheck',
                name: 'Code Check',
                creative: balance,
                position: code
            });
            // Send the promo_click action with an event.
            ga('ec:setAction', 'promo_click');
            ga('send', 'event', 'Internal Promotions', 'click', 'Code Check');
        }

        var API = {
            trackRequest: function (response) {
                if (isGALoaded()) {
                    trackECommerce(response.code, response.balance);
                    trackEvent(response.code, response.status, response.balance);
                }
            },
            sendScrollDepthEvent: function (label, data) {
                if (!isGALoaded()) {
                    return null;
                }

                if (data.event === 'ScrollTiming') {
                    ga('send', 'timing', {
                        timingCategory: label,
                        timingVar: data.eventAction,
                        timingValue: data.eventTiming,
                        timingLabel: data.eventLabel
                    });
                } else {
                    ga('send', 'event', {
                        eventCategory: label,
                        eventAction: data.eventAction,
                        eventLabel: data.eventLabel,
                        nonInteraction: data.eventNonInteraction
                    });
                }
            },
            sendCartUpdate: function (action, product) {
                if (isGALoaded() && (action === 'add' || action === 'remove')) {
                    var label = action === 'add' ? 'Add to Cart' : 'Remove from Cart';

                    ga('ec:addProduct', product);
                    ga('ec:setAction', action);
                    gtag('event', 'Cart action', {
                        'event_category': 'Cart',
                        'event_label': label,
                        'event_value': product
                    });
                }
            }
        };
        return API;
    }());

    var CouponAnalyzer = (function () {
        var responses = {
            e: {
                message: 'Sorry, your card has expired.',
                status: 'expired'
            },
            c: {
                message: 'Please Call 1.855.922SPIN',
                status: 'call'
            },
            l: {
                message: 'Maximum number of attempts reached, try tomorow or call 1.855.922SPIN',
                status: 'limit'
            },
            u: {
                message: 'Card already used',
                status: 'used'
            },
            number: {
                message: 'Hurray! Your card has <strong>$<!--amount--></strong>. <br> <ln class="balanceln">*Credit will apply checkout</ln><br>',
                status: 'valid'
            },
            fallback: {
                message: 'Sorry, your code is invalid.',
                status: 'invalid'
            },
            timeout: {
                message: 'Error. Please Call 1.855.922SPIN',
                status: 'invalid'
            },
            wrong: {
                message: 'Sorry, you entered the wrong number.',
                status: 'wrong'
            }
        };

        var balanceCheckForm = null,
            workspace = null,
            messageBoard = null,
            url = 'https://track-dot-guextserver.appspot.com/giftcard';

        /**
         * Save Cookies & Update the UI
         *
         * @param {type} response
         * @param {type} showEverything
         */
        function setCookiesAndUpdateUI(response, showEverything) {
            GoogleAnalytics.trackRequest(response);
            cookieManager.setItem('status', response.status, false, '/');
            messageBoard.html(response.message);

            if (response.balance) {
                cookieManager.setItem('discount', response.code, false, '/');
                cookieManager.setItem('balance', response.balance, false, '/');
            } else {
                cookieManager.removeItem('discount', '/');
                cookieManager.removeItem('balance', '/');
            }

            showEverything ? $('div.balanceenter').show() : null;
            $('p.gifttext').hide();
            $('div.balanceblock').show();
        }

        /**
         * Handle the Ajax response, update UI, and push events at Google Analytics
         *
         * @param {string|object} data on succes: the response recieved from the server
         *                           on failure: the jqXHR object
         * @param {string} status
         *
         */
        function handleAjaxResponse(data, status) {
            var response = null;

            if (data === '' || typeof data === 'object') {
                response = responses[status] !== undefined ? responses[status] : responses.fallback;
            } else if (isNaN(data)) {
                response = responses[data] !== undefined ? responses[data] : responses.fallback;
            } else {
                response = $.extend({}, responses.number);
                response.balance = data;
                response.message = response.message.replace('<!--amount-->', data);
            }

            var values = this.url.split('=');
            response.code = values[2];

            setCookiesAndUpdateUI(response, true);
        }

        /**
         * Intercepts the form 'submit' action and performs the Ajax request
         *
         * @param event the submit event
         */
        function interceptCouponFormSubmission(event) {
            event.preventDefault();
            var form = $(event.target);
            var code = $('input[name=code]', form).val();
            var email = $('input[name=email]', form).val();

            if (code.length < 6) {
                // If coupon code is less than 6 characters in length
                setCookiesAndUpdateUI(responses.wrong, false);
                return false;
            }

            messageBoard.html('<div class="lds-ring"><div></div><div></div><div></div><div></div></div> <div class="text-ring">Wait checking your card...</div>');
            $('div.balanceblock').show();

            $.ajax({
                url: url,
                type: "GET",
                timeout: 10000,
                data: "e=" + email + "&d=" + code + "",
                success: handleAjaxResponse,
                error: handleAjaxResponse,
                xhrFields: {
                    withCredentials: false
                }
            });
        }

        var API = {
            initialize: function () {
                workspace = $('div.giftcardblock');
                balanceCheckForm = $('form#check-balance', workspace);

                if (balanceCheckForm.length === 0) {
                    return null;
                }

                messageBoard = $('p.balance', workspace);
                balanceCheckForm.on('submit', interceptCouponFormSubmission);
            }
        };

        return API;
    }());

    var ScrollDepthTracker = (function () {

        function attachDepthTracker(label, elements) {
            if (elements.length !== $(elements.join(',')).length) {
                window.console.log('Cannot initialize scroll depth tracker for ' + label);
                return null;
            }

            if ($.scrollDepth === undefined) {
                window.console.log('Scroll Depth plugin not loaded');
                return null;
            }

            $.scrollDepth({
                percentage: true,
                userTiming: true,
                pixelDepth: false,
                nonInteraction: true,
                eventHandler: function (data) {
                    //GoogleAnalytics.sendScrollDepthEvent(label, data);
                    mixpanel.track(label, {
                        "Action": "Scroll",
                        "Type": "Scroll",
                        "Label": data.eventLabel
                    });

                    // window.console.log(label + data.eventLabel);

                }
            });

            window.console.log('Scroll Depth initialized for ' + label);
        }

        var API = {
            initialize: function () {
                // Attach depth tracker to the home page
                attachDepthTracker('Scroll Home Page', ['#shopify-section-header-v1', '#home_top_section', '#home_second_section', '#home_third_section', '#home_fourth_section', '#home_fifth_section', '#home_sixth_section', '#home_seventh_section', '#home_eighth_section', '#home_nineth_section', '#home_tenth_section', '#home_eleventh_section', '#newsletter_section', '#footer']);
                // Attach the depth tracker to the cart items
                attachDepthTracker('Scroll Cart', ['#packs', '#products', '#stands', '#extras', '.cart-area', '#copyrightcart']);
            }
        };

        return API;
    }());






    var CartTracker = (function () {
        var internalCart = null;

        function convertResponseToStructuredObject(items) {
            var structuredItems = {};

            for (var i in items) {
                var item = items[i];
                structuredItems[item.sku] = {
                    id: item.sku,
                    name: item.title,
                    material: item.product_title,
                    size: item.variant_title,
                    category: item.product_type,
                    brand: item.vendor,
                    price: item.price / 100,
                    quantity: item.quantity
                };
            }

            return structuredItems;
        }

        function isCartRequest(options) {
            if (options.url === '/cart/update.js' && options.type === 'POST') {
                return true;
            }

            return false;
        }

        function checkQuantityChanged(items) {

            if (items === undefined) {
                return null;
            }

            if (internalCart !== null) {
                var newItems = convertResponseToStructuredObject(items);
                var allItems = $.extend({}, internalCart, newItems);

                for (var id in allItems) {

                    if (newItems[id] === undefined) {

                        // Item Removed
                        internalCart[id].quantity = 0;
                        GoogleAnalytics.sendCartUpdate('remove', internalCart[id]);

                        // Safe mixpanel tracking with error handling
                        try {
                            if (typeof mixpanel !== 'undefined') {
                                mixpanel.track("Removed Cart", allItems[id]);
                            }
                        } catch (e) {
                            console.log('Mixpanel tracking failed:', e);
                        }
                    } else if (internalCart[id] === undefined) {

                        // New Item added
                        GoogleAnalytics.sendCartUpdate('add', newItems[id]);
                        // Safe mixpanel tracking with error handling
                        try {
                            if (typeof mixpanel !== 'undefined') {
                                mixpanel.track("Added Cart", newItems[id]);
                            }
                        } catch (e) {
                            console.log('Mixpanel tracking failed:', e);
                        }
                    } else if (internalCart[id].quantity === newItems[id].quantity) {

                        // Quantity unchanged

                    } else if (internalCart[id].quantity > newItems[id].quantity) {

                        // Quantity of Product Reduced
                        GoogleAnalytics.sendCartUpdate('remove', newItems[id]);
                        // Safe mixpanel tracking with error handling
                        try {
                            if (typeof mixpanel !== 'undefined') {
                                mixpanel.track("Removed Cart", allItems[id]);
                            }
                        } catch (e) {
                            console.log('Mixpanel tracking failed:', e);
                        }
                    } else if (internalCart[id].quantity < newItems[id].quantity) {

                        // Quantity of Product Increased
                        GoogleAnalytics.sendCartUpdate('add', newItems[id]);
                        // Safe mixpanel tracking with error handling
                        try {
                            if (typeof mixpanel !== 'undefined') {
                                mixpanel.track("Added Cart", newItems[id]);
                            }
                        } catch (e) {
                            console.log('Mixpanel tracking failed:', e);
                        }

                        //window.console.log('Product ' + JSON.stringify(newItems[id]));

                    }
                }
            }

            internalCart = convertResponseToStructuredObject(items);
        }

        function ajaxSuccessInterceptor(event, jqXHR, ajaxOptions, response) {
            if (!isCartRequest(ajaxOptions)) {
                return null;
            }

            checkQuantityChanged(response.items);


        }

        var API = {
            initialize: function () {
                $(document).ajaxSuccess(ajaxSuccessInterceptor);

                updatecart();
            }
        };

        return API;
    }());

    var MediaTracker = (function () {

        var currentContent = null,
            elementActions = {
                gallery: {
                    open: {
                        action: 'Open Image',
                        timer: Timer.start
                    },
                    close: {
                        action: 'Close Image',
                        timer: Timer.stop
                    }
                },
                video: {
                    open: {
                        action: 'Open Video',
                        timer: Timer.start
                    },
                    close: {
                        action: 'Close Video',
                        timer: Timer.stop
                    }
                },
                imagegallery: {
                    open: {
                        action: 'Open Slider',
                        timer: Timer.start
                    },
                    next: {
                        action: 'Next Slide',
                        timer: Timer.restart
                    },
                    prev: {
                        action: 'Previous Slide',
                        timer: Timer.restart
                    },
                    close: {
                        action: 'Close Slider',
                        timer: Timer.stop
                    }
                }
            };

        function getMediaLabelOrLocation(target) {
            var label = target.data('label');

            while (label === undefined || label === '') {
                label = target.attr('id');
                target = target.parent();
            }

            return label;
        }

        function getModalContentUrl(item) {
            if (item !== undefined && item.src.length !== 0) {
                currentContent = item;
            }

            return currentContent.src;
        }

        function sendMediaEvent(category, action, filename, value) {
            if (value) {
                value = Math.round(value);
            }

            // Check if Google Analytics is available before using it
            if (typeof ga === 'function') {
                ga('send', 'event', {
                    eventCategory: category,
                    eventAction: action,
                    eventLabel: filename,
                    eventValue: value
                });
            }

            mixpanel.track(action, {
                "Category": category,
                "Filename": filename,
                "Action": action,
                "Value": value
            });

        }

        function handleVideoEvent(event) {
            var video = event.target;
            var action = null;

            switch (event.type) {
                case 'pause':
                    action = (video.currentTime === video.duration) ? 'Playback Ended' : 'Video Paused';
                    break;

                case 'playing':
                    action = (video.currentTime === 0) ? 'Begining Playback' : 'Resuming Playback';
                    break;

                default:
                    return null;
            }



            var playbackPosition = 100 * (video.currentTime / video.duration);
            sendMediaEvent('Video: ' + getMediaLabelOrLocation($(video)), action, video.currentSrc, playbackPosition);
        }



        function pausevid() {


            $('video').each(function () {
                $(this)[0].pause();
            });


        }

        /**
         * Handle Events related to the Magnific Popup modal window
         *
         * @param {Event} event the event that triggered the handler
         * @param {jQuery} newItem the item passed to the modal window
         */
        function handleModalEvent(event, newItem) {
            var element = $(event.target);
            var type = event.type.slice(3).toLowerCase();
            var label = getMediaLabelOrLocation(element);

            if (type === 'change' && currentContent === null) {
                getModalContentUrl(newItem);

                return null;
            }

            if (element.attr('id') === 'gallery') {
                label = 'Gallery: ' + label;
                element = elementActions.gallery;
            } else if (element.hasClass('open-popup-link')) {
                label = 'Video: ' + label;
                element = elementActions.video;
            } else if (element.hasClass('imagegallery')) {
                if (type === 'change') {
                    var diff = newItem.index - currentContent.index;
                    currentContent = newItem;

                    type = (diff === 1 || diff < -1) ? 'next' : 'prev';
                }

                label = 'Slider: ' + label;
                element = elementActions.imagegallery;
            }

            if (typeof element[type] === 'object') {
                sendMediaEvent(label, element[type].action, currentContent.src, element[type].timer());
            }

            if (type === 'close') {
                currentContent = null;
            }
        }

        var API = {
            initialize: function () {
                $('video').on('play playing pause abort ended', handleVideoEvent);
                $('#gallery, a.open-popup-link, .imagegallery').on('mfpOpen mfpClose mfpChange', handleModalEvent);
                $('a.open-popup-link').on('mfpClose', pausevid);
            }
        };

        return API;
    }());

    /**
     * Executes when everything is loaded
     */
    function initializeOnLoad() {
        ScrollDepthTracker.initialize();
        window.console.log('Everything loaded');
    }

    /**
     * Executes when the DOM is loaded
     */
    function bootstrap() {
        $(window).on('load', initializeOnLoad);
        CouponAnalyzer.initialize();
        MediaTracker.initialize();
        CartTracker.initialize();
        window.console.log('Analytics.js loaded');
    }

    $(bootstrap);
}(jQuery));


$(document).ready(function (sParam) {

    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
            return sParameterName[1];
        }
    }

    var distinct_id = getUrlParameter('e');
    mixpanel.identify(distinct_id);
});


function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}
var coupon = getUrlVars()["c"];
if (coupon) {
    var tturl = 'https://squaremade-com.myshopify.com/discount/' + coupon;
    var xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
            var response = xmlhttp.responseText; //if you need to do something with the returned value
        }
    }

    xmlhttp.open("GET", tturl, true);
    xmlhttp.send();
    gtag('event', 'discount code applied', {
        'event_category': 'Visitor with coupon link',
        'event_label': 'discount applied',
        'event_value': coupon
    });
    mixpanel.track("Visitor with coupon link", {
        "Action": "discount code applied",
        "Type": "Visitor with coupon link",
        "Label": "discount applied"
    });
    console.log("Coupon " + coupon + " Applied");
}


